import {
  IData_Booking_Settings_Org,
  IData_Booking_General_Config,
} from '@kaidam/fc-shared/src/types/schema/booking'

export const DEFAULT_GENERAL_CONFIG: IData_Booking_General_Config = {
  new_booking_email_template: '',
  updated_booking_email_template: '',
  cancelled_booking_email_template: '',
  admin_booking_email_template: '',
  coverage_outcodes: '',
  travel_time_before: 0,
  travel_time_after: 0,
  slot_interval: 0,
  // how many days from today are bookings available to book?
  buffer_zone: 0,
  cutoff_zone: 0,
  contact_email: '',
  contact_phone: '',
}

export const DEFAULT_SETTINGS: IData_Booking_Settings_Org = {
  project: '',
  ets: [],
  settings: {
    pricing: {
      products: [],
    },
    general_config: DEFAULT_GENERAL_CONFIG,
  }
}
